/**
 * Codes de refus du quota analytics renvoyés par l'edge function hyper-task
 * (#1475). Module sans dépendance : importé par SecureGeminiService et par
 * PollAnalyticsPanel.
 */
export const ANALYTICS_ERROR_CODES = [
  "ANALYTICS_AUTH_REQUIRED",
  "ANALYTICS_QUOTA_EXCEEDED",
  "ANALYTICS_QUOTA_UNAVAILABLE",
] as const;
export type AnalyticsErrorCode = (typeof ANALYTICS_ERROR_CODES)[number];

/** Code de refus analytics renvoyé par hyper-task, s'il figure dans le texte. */
export function analyticsErrorCode(
  text: string | undefined | null,
): AnalyticsErrorCode | null {
  if (!text) return null;
  return ANALYTICS_ERROR_CODES.find((c) => text.includes(c)) ?? null;
}
